import Filter from "../components/Filter";
import { Grid } from "@mui/material";
import PropertyCard from "../components/PropertyCard";
import axios from "axios";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { API_URL } from "../config/api";

export const ListingsPage: React.VFC = () => {
  const [listings, setListings] = useState([]);
  const [shouldUpdate, setShouldUpdate] = useState(true);

  useEffect(() => {
    if (shouldUpdate) {
      axios.get(`${API_URL}/listings`).then((res) => {
        setListings(res.data);
      });
      setShouldUpdate(false);
    }
  }, [shouldUpdate]);

  // parse the url params
  const searchParams = useSearchParams();
  const location = searchParams[0].get("location");
  const propertyType = searchParams[0].get("propertyType");
  const price = searchParams[0].get("price") as unknown as string;

  console.log("location", location);
  console.log("propertyType", propertyType);
  console.log("price", price);

  const [filteredListings, setFilteredListings] = useState(listings);

  useEffect(() => {
    console.log("the use effect is running");
    const filteredListings = listings.filter((listing: any) => {
      // Check location filter - only apply if location is provided and not empty
      if (
        location &&
        location !== "" &&
        location !== "undefined" &&
        location !== "null"
      ) {
        if (listing.location?.city !== location) {
          return false;
        }
      }

      // Check property type filter - only apply if propertyType is provided and not empty
      if (
        propertyType &&
        propertyType !== "" &&
        propertyType !== "undefined" &&
        propertyType !== "null"
      ) {
        if (listing.propertyType !== propertyType) {
          return false;
        }
      }

      // Check price filter - only apply if price is provided and not empty
      if (price && price !== "" && price !== "undefined" && price !== "null") {
        const priceRange = price.split(",").map(Number);

        // Handle cases where only one price is provided
        const hasFromPrice = priceRange[0] && !isNaN(priceRange[0]);
        const hasToPrice = priceRange[1] && !isNaN(priceRange[1]);

        if (hasFromPrice && listing.price < priceRange[0]) {
          return false;
        }

        if (hasToPrice && listing.price > priceRange[1]) {
          return false;
        }
      }

      return true;
    });
    setFilteredListings(filteredListings);
  }, [price, listings, location, propertyType]);

  return (
    <div>
      <Filter
        location={location}
        propertyType={propertyType}
        price={price !== "" ? price?.split(",").map(Number) : []}
        listings={listings}
      />

      <Grid
        container
        spacing={2}
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          padding: "1rem",
        }}
        id="list"
      >
        {
          // @ts-ignore
          [...filteredListings].map(
            // .sort(
            //     (a, b) => new Date(b.listedDate) - new Date(a.listedDate)
            //   ),
            ({
              title,
              price,
              wholeArea,
              _id,
              photos,
              location,
              propertyType,
            }: any) => (
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.2 }}>
                <PropertyCard
                  key={_id}
                  property={{
                    title,
                    price,
                    wholeArea,
                    _id,
                    photos,
                    location,
                    propertyType,
                  }}
                />
              </Grid>
            )
          )
        }
      </Grid>
    </div>
  );
};

export default ListingsPage;
